import React from "react";
import { Card } from "react-bootstrap";
import { BenefitRow } from "../interface";

interface TariffPlansBenefitsCardProps {
    title: string;
    promoText?: React.ReactNode;
    rows: BenefitRow[];
}

const TariffPlansBenefitsCard: React.FC<TariffPlansBenefitsCardProps> = ({ title, promoText, rows }) => {
    return (
        <Card className="rounded-4 h-100">
            <Card.Body className="p-4 border-secondary border rounded-4 h-100">
                <div style={{ minHeight: 106 }}>
                    <div className="fs-20 mb-2">{title}</div>
                    {promoText ? <div className="fs-7">{promoText}</div> : null}
                </div>

                <div className="d-flex flex-column">
                    {rows.map((row, index) => (
                        <div key={row.id} className={`py-2 ${index !== rows.length - 1 ? "border-bottom" : ""}`}>
                            <span className={row.isEmphasis ? "fw-bold" : ""}>{row.label}</span>
                        </div>
                    ))}
                </div>
            </Card.Body>
        </Card>
    );
};

export default TariffPlansBenefitsCard;
